module.exports = __webpack_public_path__ + "CDH Client Template.xlsx";